import * as React from "react";
import { RouteInfo } from "../../../lib/routing";

const Renderer: React.SFC<{ routeInfo: RouteInfo<any> }> = ({ routeInfo }) => {
  return (
    <routeInfo.component routeParams={routeInfo.params} routePath={routeInfo.path} routeQuery={routeInfo.query}>
      {routeInfo.children && <Renderer routeInfo={routeInfo.children} />}
    </routeInfo.component>
  );
};

export default Renderer;



// WEBPACK FOOTER //
// ./frontend/src/common/components/router/Renderer.tsx